import { type Question } from '@/components/pages/Home/types';
import { i18n } from '@/translate/i18n';

export const faqList: Question[] = i18n.t('faq.questions', {
  returnObjects: true,
});
